const DEV_DATE_KEY = 'devDateOverride';

export function getDevDate() {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  // Support both ?devDay=2026-05-20 and ?devDay=2026-05-20T23:59
  const paramDate = params.get('devDay');
  if (paramDate && /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2})?$/.test(paramDate)) {
    localStorage.setItem(DEV_DATE_KEY, paramDate);
    return paramDate;
  }
  return localStorage.getItem(DEV_DATE_KEY);
}

export function setDevDate(dateStr) {
  if (dateStr) {
    localStorage.setItem(DEV_DATE_KEY, dateStr);
  } else {
    localStorage.removeItem(DEV_DATE_KEY);
  }
}

export function clearDevDate() {
  localStorage.removeItem(DEV_DATE_KEY);
}

export function getCurrentDate() {
  const override = getDevDate();
  if (override) {
    // If time included, use it; otherwise default to 12:00
    const dateStr = override.includes('T') ? override : override + 'T12:00';
    const d = new Date(dateStr);
    if (!isNaN(d.getTime())) return d;
  }
  return new Date();
}

export function getTodayString() {
  return formatDateHelsinki(getCurrentDate());
}

export function formatDateHelsinki(date = new Date()) {
  return date.toLocaleDateString('sv-SE', { timeZone: 'Europe/Helsinki' });
}

export function isDevMode() {
  return !!getDevDate();
}

export function advanceDevDate(days) {
  const current = getDevDate();
  const base = current
    ? new Date(current.includes('T') ? current : current + 'T12:00')
    : new Date();
  base.setDate(base.getDate() + days);
  const newDate = base.toLocaleDateString('sv-SE', { timeZone: 'Europe/Helsinki' });
  setDevDate(newDate);
  return newDate;
}
